<!-- MapView.vue -->
<template>
    <div class="amap-container">
        <div id="mapContainer" style="width: 100vw; height: 60vh;"></div>
        <div class="class_poins">
            <div v-for="(item, index) in points" :key="index">
                <div class="poins_item">
                    <div class="item_text"> {{ item.address }}</div>
                    <el-button type="danger" @click="delAddesss(index)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="buton_div">
            <button hover-class="button-hover" @click="submitAddress" class="_button">
                提交地址
            </button>
        </div>
        <!-- <el-input v-model="inputInput"></el-input>
        <button @click="getText">获取地址</button> -->
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import AMapLoader from '@amap/amap-jsapi-loader';
import { Toast } from 'mint-ui';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
// 定义类型
interface Point {
    lng: number;
    lat: number;
    address?: string;
}
// 告诉 TypeScript AMap 是全局变量
declare const AMap: any;
interface Marker {
    id: number;
    position: [number, number]; // [lng, lat]
    title: string;
}

@Component
export default class MapView extends Vue {
    // 初始中心点 [经度, 纬度]
    center: [number, number] = [116.397428, 39.90923];

    @lazyInject(ShopService)
    shopService!: ShopService;

    // 插件
    plugin = ['ToolBar', 'Scale'];
    inputInput = '';
    // 点击的点
    clickedPoint: Point | null = null;
    clickInfo = '点击地图获取位置信息';
    map: any = null;
    geocoder: any = null;
    districtBoundaries: any[] = [];
    // 🔥 新增：存储点位和覆盖物
    markers: any[] = [];        // 存储 Marker 实例
    circles: any[] = [];        // 存储 Circle 实例
    points: Array<{ lng: number; lat: number; address: string }> = []; // 存储数据
    poiPoints: any[] = [];

    getText() {
        this.highlightDistrict(this.inputInput);
    }

    async submitAddress() {
        console.log('提交地址', this.points);
        const { poi } = this.$route.params;

        const params: any = {
            virtual_poi: poi,
            point: this.points.map((res: any) => { return { longitude: res.lng, latitude: res.lat, radius: '8000' } }),
        };
        console.log(params, 'params');
        const res = await this.shopService.getPointAdd(params);
        if (res) {
            Toast('提交成功');
        }
        // this.$router.push({ name: 'ShopDetail', params });

    }

    async onMounted(name: any) {
        try {
            await AMapLoader.load({
                key: '6f5a626b93850e6e0d46610046818b13', // 申请的高德 Key
                version: '2.0',
                plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.DistrictSearch', 'AMap.Geocoder', 'AMap.Circle', 'AMap.Pixel'],
            });
            const map = new AMap.Map('mapContainer', {
                zoom: 10,
                center: [116.397428, 39.90923],
                resizeEnable: true,
            });
            // 创建地理编码器
            this.geocoder = new AMap.Geocoder();
            map.addControl(new AMap.Scale());
            map.on('click', this.handleMapClick);
            // console.log('地图加载完成', map);
            this.map = map;
            // map.addControl(new AMap.ToolBar());
            this.$nextTick(() => {
                this.highlightDistrict(name);
            });
        } catch (e) {
            console.error('地图加载错误', e);
        }
        // 逆地理编码：坐标 → 地址
    }
    mounted() {
        const { poi, time, sign } = this.$route.params;
        const params = {
            virtual_poi: poi,
            timeStamp: time,
            sign,
        }
        this.getPointList(params);
        // this.onMounted();
    }

    async getPointList(params: any) {
        const res = await this.shopService.getPointList(params);
        this.onMounted(res.cityCode);
        this.poiPoints = res.poi_point;
    }

    highlightDistrict(districtName: string) {
        // 创建行政区查询实例
        const districtSearch = new AMap.DistrictSearch({
            level: 'city', // 查询级别，可选：country, province, city, district
            extensions: 'all', // 返回边界坐标
        });
        districtSearch.search(`${districtName}`, (status: string, result: any) => {
            // console.log(status, result);
            if (status === 'complete' && result.districtList?.length) {
                const bounds = result.districtList[0].boundaries;
                if (bounds && bounds.length > 0) {
                    this.districtBoundaries = bounds;
                    // 绘制多边形覆盖物
                    const districtPolygon = new AMap.Polyline({
                        path: bounds, // 使用第一个环作为路径
                        strokeColor: '#f00', // 线条颜色
                        strokeWeight: 5,       // 线条宽度
                        strokeOpacity: 1,    // 透明度
                        lineCap: 'round',      // 线头样式：round | square | butt
                        lineJoin: 'round',     // 转折点样式
                        zIndex: 10,
                    });
                    this.map.add(districtPolygon);
                    // 自动缩放视野到该区域
                    this.map.setFitView(districtPolygon);
                    this.poiPoints.forEach((res: any) => {
                        // this.addPoint(res.longitude, res.latitude, res.address, poi);
                        const lnglat = {
                            lng: res.longitude,
                            lat: res.latitude,
                        };
                        this.geocoder.getAddress(lnglat, (status: string, result: any) => {
                            if (status === 'complete' && result.regeocode) {
                                const address = result.regeocode.formattedAddress;
                                const poiName = result.regeocode.poiList?.pois[0]?.name || '未知地点';
                                // console.log('poiName:', poiName);
                                this.addPoint(lnglat.lng, lnglat.lat, address, poiName);
                                // this.clickInfo = `✅成功！<br>经纬度: ${lng}, ${lat}<br>地址: ${address}      `;
                            } else {
                                this.clickInfo = `✅ 位置有效，但地址解析失败`;
                            }
                        });
                    });
                } else {
                    console.warn('该区域无边界数据');
                }
            } else {
                console.error('行政区查询失败:', result);
            }
        });
    }

    addPoint(lng: number, lat: number, address: string, poiName: string) {
        // console.log('添加点位', lng, lat, address, poiName);
        // console.log('markers 长度:', this.markers);

        if (this.markers.length >= 3) {
            return;
        }

        // ✅ 创建 Marker
        const marker = new AMap.Marker({
            position: [lng, lat],
            title: address,
            label: {
                content: address,  // 文字内容，如 "点1"
                // offset: new AMap.Pixel(0, -30),           // 相对于 icon 的偏移
                direction: 'top',                         // 定位方向：top | bottom | left | right
                style: {
                    // backgroundColor: '#1890FF',             // 背景色
                    color: '#fff',                          // 字体颜色
                    // borderColor: '#1890FF',                 // 边框颜色
                    borderRadius: '4px',
                    padding: '4px 8px',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    whiteSpace: 'normal', // 允许换行
                    maxWidth: '50px',
                    display: 'block'      // 让 maxWidth 生效
                    // whiteSpace: 'nowrap'                    // 防止换行
                }
            },
        });

        // ✅ 创建 8000 米半径的圆形覆盖物
        const circle = new AMap.Circle({
            center: [lng, lat],           // 圆心
            radius: 8000,                 // 半径（米）
            strokeColor: '#3366FF',       // 边框颜色
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#3366FF',
            fillOpacity: 0.25,

            zIndex: 10,
        });
        circle.on('click', this.handleMapClick);

        // 🔼 添加到地图
        this.map.add(marker);
        this.map.add(circle);
        // console.log('markers 长度:', this.markers);
        // 🔼 存入队列（先进先出）
        this.markers.push(marker);
        this.circles.push(circle);
        this.points.push({ lng, lat, address: address });

        // 🔼 更新提示信息
        // 可选：自动缩放到该点
        // this.map.setCenter([lng, lat]);
    }

    handleMapClick(e: any) {
        const lnglat = e.lnglat;
        const { lng, lat } = lnglat;
        if (this.markers.length >= 3) {
            Toast('最多添加3个点位，请删除后再添加新点位');
            return;
        }
        // 调试信息
        // console.log('boundaries 长度:', this.districtBoundaries.length);

        if (this.districtBoundaries.length === 0) {
            this.clickInfo = '❌ 行政区边界数据未加载，请稍等或更换区域';

            return;
        }
        let isInDistrict = false;
        for (const ring of this.districtBoundaries) {
            // if (!Array.isArray(ring) || ring.length < 3) continue;
            if (!Array.isArray(ring)) continue;

            try {
                // 判断点是否在任意一个环内
                if (AMap.GeometryUtil.isPointInRing(lnglat, ring)) {
                    isInDistrict = true;
                    break;
                }
            } catch (err) {
                console.warn('isPointInRing 出错:', err);
            }
        }

        if (!isInDistrict) {
            this.clickInfo = '❌ 请在指定区域内点击（如朝阳区）';
            Toast('请在指定区域内点击');
            return;
        }

        // ✅ 在区域内，继续解析地址
        this.clickInfo = `✅ 位置有效，解析中... (${lng.toFixed(6)}, ${lat.toFixed(6)})`;
        this.geocoder.getAddress(lnglat, (status: string, result: any) => {
            if (status === 'complete' && result.regeocode) {
                const address = result.regeocode.formattedAddress;
                const poiName = result.regeocode.poiList?.pois[0]?.name || '未知地点';
                this.addPoint(lnglat.lng, lnglat.lat, address, poiName);
                this.clickInfo = `✅成功！<br>经纬度: ${lng}, ${lat}<br>地址: ${address}      `;
            } else {
                this.clickInfo = `✅ 位置有效，但地址解析失败: ${lng}, ${lat}`;
            }
        });
    }

    delAddesss(index: any) {
        this.points.splice(index, 1);
        this.funRedrawMarker();
    }

    funRedrawMarker() {
        // console.log('重新绘制标记');
        this.map.remove(this.markers);   // 移除所有标记
        this.map.remove(this.circles);   // 移除所有圆形覆盖物
        this.markers = [];
        this.circles = [];
        this.points.forEach(res => {
            const { lng, lat, address } = res;
            // ✅ 创建 Marker
            const marker = new AMap.Marker({
                position: [lng, lat],
                title: address,
                label: {
                    content: address,  // 文字内容，如 "点1"
                    // offset: new AMap.Pixel(0, -30),           // 相对于 icon 的偏移
                    direction: 'top',                         // 定位方向：top | bottom | left | right
                    style: {
                        // backgroundColor: '#1890FF',             // 背景色
                        color: '#fff',                          // 字体颜色
                        // borderColor: '#1890FF',                 // 边框颜色
                        borderRadius: '4px',
                        padding: '4px 8px',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        whiteSpace: 'normal', // 允许换行
                        maxWidth: '50px',
                        display: 'block'      // 让 maxWidth 生效
                        // whiteSpace: 'nowrap'                    // 防止换行
                    }
                },
            });

            // ✅ 创建 8000 米半径的圆形覆盖物
            const circle = new AMap.Circle({
                center: [lng, lat],           // 圆心
                radius: 8000,                 // 半径（米）
                strokeColor: '#3366FF',       // 边框颜色
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#3366FF',
                fillOpacity: 0.25,
                zIndex: 10,
            });
            circle.on('click', this.handleMapClick);
            // 🔼 添加到地图
            this.map.add(marker);
            this.map.add(circle);
            // console.log('markers 长度:', this.markers);
            // 🔼 存入队列（先进先出）
            this.markers.push(marker);
            this.circles.push(circle);
        });
    }
}
</script>

<style scoped lang="scss">
/* 确保地图容器可点击 */
.info-panel {
    pointer-events: none;
    /* 如果提示层在上面，禁用其事件 */
}

.amap-container {
    pointer-events: auto;
}

.class_poins {
    height: calc(40vh - 60px);
    overflow: auto;

    // border: 1px saddlebrown solid;
    .poins_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #ccc;

        .item_text {
            box-sizing: border-box;
            padding: 10px 20px;
        }

        .del_btn {
            color: red;
        }
    }
}

.buton_div {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    /* 或指定宽度 */
    /* 其他样式 */
    color: white;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    z-index: 1000;

    /* 确保在其他内容之上 */
    ._button {
        width: 80vw;
        height: 40px;
        color: #fff;
        background: #007bff;
        border: none;
    }
}

/* 或者更直接：确保地图容器在最上层 */
#app,
.amap-container,
.amap-map {
    pointer-events: auto !important;
}
</style>